'use strict';

exports.__esModule = true;
exports.transformSpecialistsReviews = exports.transformProfileReviews = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transformProfileReviews = exports.transformProfileReviews = function transformProfileReviews(reviews) {
	return (reviews || []).map(function (review) {
		return {
			date: (0, _moment2.default)(review.timestamp_created).format('DD-MM-YYYY'),
			review: review.review && review.review.body,
			rating: review.review && review.aggregate_score,
			likes: review.review && review.review.likes,
			id: review.id,
			profileType: review.practice ? 'practice' : 'specialist',
			profileId: review.practice && review.practice.id || review.specialist && review.specialist.id,
			reviewdProfileName: review.practice && review.practice.name || review.specialist && review.specialist.name
		};
	});
};

var transformSpecialistsReviews = exports.transformSpecialistsReviews = function transformSpecialistsReviews(reviews) {
	return (reviews || []).map(function (review) {
		return {
			date: (0, _moment2.default)(review.timestamp_created).format('DD-MM-YYYY'),
			review: review.specialist_review && review.specialist_review.body,
			rating: review.specialist_aggregate_review,
			likes: review.specialist_review && review.specialist_review.likes,
			profileType: review.practice ? 'practice' : 'specialist',
			profileId: review.practice || review.specialist,
			reviewdProfileName: review.specialist_review && review.specialist_review.name
		};
	});
};